import { createSelector } from "reselect";

/**
 * selector to determine if patient csv export is enabled on admin tab
 */
export const patientCsvExportEnabledSelector = createSelector(() => true);
